module.exports = __webpack_public_path__ + "img/rule-6-stickers.47a9db23.png";